import { down, close, check, inputIcons, genesisIcons } from "@formkit/icons";
// import { findSection } from "@formkit/inputs";
// import { clone } from "@formkit/utils";
import {
  booleanRadio,
  booleanStringRadio,
  panelRadio,
  required_boolean,
  all_or_none_in_group_required,
  has_no_validation,
  renameRadios,
  rootClasses,
  muiFile,
  accept_type,
  max_sum,
  less_than,
  less_than_or_equal,
  greater_than,
  greater_than_or_equal,
  type BooleanStringRadioOptions,
  type BooleanRadioOptions,
  type PanelRadioOptions,
  type MuiFile,
} from "@modernary/mui/utils/fk";
import type { FormKitNode } from "@formkit/core";
import type { FormKitInputs } from "@formkit/inputs";
import type { MaybeRef } from "@vueuse/core";

declare module "@formkit/inputs" {
  interface FormKitInputProps<Props extends FormKitInputs<Props>> {
    booleanRadio: {
      type: "booleanRadio";
      value?: boolean;
      options: MaybeRef<BooleanRadioOptions>;
      // ... props here
    };
    booleanStringRadio: {
      type: "booleanStringRadio";
      value?: string;
      options: MaybeRef<BooleanStringRadioOptions>;
    };
    panelRadio: {
      type: "panelRadio";
      value?: string | number | boolean;
      options: MaybeRef<PanelRadioOptions>;
      // ... props here
    };
    muiFile: {
      type: "muiFile";
      value?: MuiFile[];
      accept?: string;
      multiple?: boolean;
      removeLabel?: string;
      displayName?: string;
      categoryMurn?: string;
      typeMurn?: string;
    };
  }
}

export const formKitConfig = {
  plugins: [renameRadios],
  rules: {
    all_or_none_in_group_required,
    has_no_validation,
    required_boolean,
    accept_type,
    max_sum,
    less_than,
    less_than_or_equal,
    greater_than,
    greater_than_or_equal,
  },
  messages: {
    en: {
      validation: {
        all_or_none_in_group_required({ args, name, node }: { args: any; name: string; node: FormKitNode }) {
          return `${name} is required`;
        },
        accept_type({ args, name, node }: { args: any; name: string; node: FormKitNode }) {
          return `${name} must be one of the following types: ${node.props.attrs.accept}`;
        },
      },
    },
  },
  inputs: {
    booleanRadio,
    booleanStringRadio,
    panelRadio,
    muiFile,
  },
  icons: {
    ...genesisIcons,
    documentPlus: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" /></svg>`,
    checkCircleIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" /></svg>`,
    xCircleIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" /></svg>`,
    noSymbolIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5"><path fill-rule="evenodd" d="M5.965 4.904l9.131 9.131a6.5 6.5 0 00-9.131-9.131zm8.07 10.192L4.904 5.965a6.5 6.5 0 009.131 9.131zM4.343 4.343a8 8 0 1111.314 11.314A8 8 0 014.343 4.343z" clip-rule="evenodd" /></svg>`,
  },
  config: {
    rootClasses,
  },
};
